import Layout from 'presentation/container/Layout/Layout';
import './App.scss';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginPage from 'presentation/container/LoginPage/LoginPage';
import SuccessPage from 'presentation/components/SuccessPage/SuccessPage';
import BrowserCompatibility from 'presentation/components/BrowserCompatibility/BrowserCompatibility';
import ForgottenPassword from 'presentation/container/Password/ForgottenPassword/ForgottenPassword';
import ForgottenUsername from 'presentation/container/ForgottenUsernameScreen/ForgottenUsername';
import ResetPassword from 'presentation/container/Password/ResetPassword/ResetPassword';
import TaxPolicy from 'presentation/container/FooterLinks/TaxPolicy';
import ModernSlavery from 'presentation/container/FooterLinks/ModernSlaveryStatement';
import CookiePolicy from 'presentation/container/FooterLinks/CookiePolicy';
import CookieDeclaration from 'presentation/container/CookieDeclaration/CookieDeclaration';
import TermsOfWebsiteLoader from 'presentation/container/FooterLinks/TermsOfWebsiteLoader/TermsOfWebsiteLoader';
import { useEffect } from "react";
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useTranslation } from 'react-i18next';
import PrivacyPolicyLoader from 'presentation/container/FooterLinks/PrivacyPolicyLoader/PrivacyPolicyLoader';
import CookiePolicyDK from 'presentation/container/FooterLinks/Denmark/CookiePolicyDK';
import OneLinkSolutionsPT from 'presentation/container/TopLinks/Portugal/OneLinkSolutionsPT';
import TermsAndConditionsLoader from 'presentation/container/FooterLinks/TermsAndConditionsLoader/TermsAndConditionsLoader';
import EnquireFormLoader from './presentation/container/TopLinks/EnquireFormLoader/EnquireFormLoader';
import MoreInformationLoader from 'presentation/container/FooterLinks/MoreInformationLoader/MoreInformationLoader';
import AboutUsLoader from 'presentation/container/TopLinks/AboutUsLoader/AboutUsLoader';
import ForgottenDetails from 'presentation/container/ForgottenDetails/ForgottenDetails';

function App() {

  const { i18n } = useTranslation();
  const region = useSelector((state: RootState) => state.region.region);

  useEffect(() => {
    i18n.changeLanguage(region.toLowerCase());
  }, [region, i18n]);

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<LoginPage />} />
          <Route path=":urlRegion" element={<LoginPage />} />
          <Route path='forgottenPassword' element={<ForgottenPassword />} />
          <Route path='forgottenUsername' element={<ForgottenUsername />} />
          <Route path='forgottenDetails' element={<ForgottenDetails />} />
          <Route path="/resetPassword" element={<ResetPassword />} />
          <Route path="/submitted" element={<SuccessPage />} />
          <Route path="/termsAndConditions/:source?" element={<TermsAndConditionsLoader />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicyLoader />} />
          <Route path="/corpayTaxPolicy" element={<TaxPolicy />} />
          <Route path="/modernSlaveryStatement" element={<ModernSlavery />} />
          <Route path="/termsOfWebsite" element={<TermsOfWebsiteLoader />} />
          <Route path="/cookiePolicy" element={<CookiePolicy />} />
          <Route path="/browser-compatibility" element={<BrowserCompatibility />} />
          <Route path="/cookieDeclaration" element={<CookieDeclaration />} />
          <Route path='/enquireForm' element={<EnquireFormLoader />} />
          <Route path="/cookiePolicyDK" element={<CookiePolicyDK />} />
          <Route path="/aboutUs" element={<AboutUsLoader />} />
          <Route path="/onelinksolutionsPT" element={<OneLinkSolutionsPT />} />
          <Route path="/moreInformation" element={<MoreInformationLoader />} />
          <Route path='*' element={<h1>Not Found</h1>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
